import AcShareVoucherLandingPage from "@alipay/ac-share-voucher-landing-page";

export default {
  components: {
    "ac-share-voucher-landing-page": AcShareVoucherLandingPage,
  },
  blocks: [
    {
      template: {
        code: "ac-share-voucher-landing-page",
        name: "AcShareVoucherLandingPage",
        cdnUrl:
          "https://cdn.marmot-cloud.com/storage/one-market/iquic/ac-share-voucher-landing-page/0.0.6",
        category: "COMMON",
        npmName: "@alipay/ac-share-voucher-landing-page",
        npmVersion: "0.0.9001682120-dev.39",
        version: "1.1.0",
        tagCodes: [{ language: "en_US", tags: [] }],
      },
      staticProperties: [],
      allStaticProperties: [],
      spaceProperties: [
        [
          {
            language: "en_US",
            properties: {
              openBtnText: "Open Touch n‘ Go eWallet",
              downLoadBtnText: "Download Touch n‘ Go eWallet",
              img: "https://cdn.marmot-cloud.com/storage/iquic-mng/prod/APLUS_REWARDS/gif/128ed096-cc08-4e9b-bfc6-83ab34321c84.gif",
              title: "Your friend shared a voucher with you.",
              contentType: "default",
            },
          },
        ],
      ],
      allSpaceProperties: [],
      blockId: "2023112332368842",
      blockCode: "ac-share-voucher-landing-pageIjuVpb",
      properties: [
        {
          language: "en_US",
          defaultProperty: true,
          properties: {
            $bizTag: {
              spma: "aac",
              spmc: "cSharevoucherLoadingpage",
              spmd: { OkBtn: "", Refresh: "" },
              spmb: "券分享",
            },
            $spm: {
              spma: "a1702",
              spmb: "b73062",
              spmc: "c341340",
              spmd: {
                OkBtn: "d393164",
                RefreshBtn: "d393165",
                OpenBtn: "d393803",
                DownLoadBtn: "d393804",
              },
            },
            openBtnText: "Open Touch n‘ Go eWallet",
            downLoadBtnText: "Download Touch n‘ Go eWallet",
            img: "https://cdn.marmot-cloud.com/storage/iquic-mng/prod/APLUS_REWARDS/gif/128ed096-cc08-4e9b-bfc6-83ab34321c84.gif",
            title: "Your friend shared a voucher with you.",
            contentType: "default",
          },
        },
      ],
      isStatic: true,
    },
  ],
  page: {
    $spm: { spma: "a1702", spmb: "b73062" },
    $bizTag: { spma: "aac", spmb: "券分享" },
  },
};
